<h1 mat-dialog-title>
  <app-titulo-paginas titulo="Contrato"></app-titulo-paginas>
</h1>
<mat-dialog-content>
  <div class="row">
    <div class="col-lg-3">
      <label for="contrato">Nº Contrato: </label>
      <p>{{!data.orcamento.numero ? "-" : data.orcamento.numero}}</p>
    </div>
    <div class="col-lg-3">
      <label for="contrato">CPF/CNPJ: </label>
      <p>{{!data.orcamento?.homecare?.paciente?.pessoa?.cpfcnpj ? "-" :
        data.orcamento?.homecare?.paciente?.pessoa?.cpfcnpj}}</p>
    </div>
    <div class="col-lg-6">
      <label for="paciente">Paciente:</label>
      <p>{{!data.orcamento?.homecare?.paciente?.pessoa?.nome ? "-" : data.orcamento?.homecare?.paciente?.pessoa?.nome
        | titlecase}}
      </p>
    </div>
  </div>
  <div class="row">
    <div class="col-lg-3">
      <label for="processo">Nº Processo: </label>
      <p>{{!data.orcamento.processo ? "-" : data.orcamento.processo}}</p>
    </div>
    <div class="col-lg-3">
      <label for="contrato">Tipo: </label>
      <p>{{!data.orcamento.cliente.tipo ? "-" : data.orcamento.cliente.tipo}}</p>
    </div>
    <div class="col-lg-6">
      <label for="cliente">Cliente (Tomador):</label>
      <p>{{data.orcamento.cliente.code ? data.orcamento.cliente.code : ""}} - {{!data.orcamento.cliente.pessoa.nome ? "-" : data.orcamento.cliente.pessoa.nome | titlecase}}</p>
    </div>
  </div>
  <div class="row">
    <div class="col-lg-3">
      <label for="data">Data do orçamento: </label>
      <p>{{!data.orcamento.data ? "-" : data.orcamento.data | date: "dd/MM/yyyy"}}</p>
    </div>
    <div class="col-lg-3">
      <label for="cidade">Cidade: </label>
      <p>{{data?.orcamento?.cidade?.nome}} - {{data?.orcamento?.cidade?.uf}}</p>
    </div>
    <div class="col-lg-3">
      <label for="ciclo">Ciclo de Meses: </label>
      <p>{{data.orcamento.quantidade ? data.orcamento.quantidade : "-"}} {{data.orcamento.unidade ?
        data.orcamento.unidade : "-"}}</p>
    </div>
    <div class="col-lg-3">
      <label for="oferta">Supervisor: </label>
      <p>{{!data.profissional ? "-" : data.profissional.pessoa.nome}}</p>
    </div>
  </div>


  <div class="row">
    <div class="col-lg-12">
      <label for="obs">Observações</label>
      <p>{{!data.orcamento.observacao ? "-" : data.orcamento.observacao}}</p>
    </div>
  </div>

  <div class="col-lg-12" style="padding: 0;">
    <div class="panel panel-default" style="margin: 20px 0;">
      <div class="panel-heading"><strong>Serviços</strong></div>
      <div class="table-responsive">
        <table class="table">
          <thead>
            <tr>
              <th>Serviço</th>
              <th>Qnt</th>
              <!-- <th>Val. Unit.</th> -->
              <th>Custo Diurno</th>
              <th>Custo Noturno</th>
              <!-- <th>Subtotal Custo</th> -->
              <!-- <th>INSS</th>
                            <th>Alíquota</th>
                            <th>ISS</th>
                            <th>Custo Mensal</th>-->
              <!-- <th>Total</th> -->
            </tr>
          </thead>
          <tbody *ngFor="let item of data.orcamento.servicos">
            <tr>
              <td>{{ item.descricao | titlecase }}</td>
              <td>{{ item?.quantidade }} {{item?.basecobranca}} {{item?.frequencia}}</td>
              <!-- <td>{{ item?.valorunitario | currency: "BRL" }}</td> -->
              <td>{{ item?.custodiurno | currency: "BRL" }}</td>
              <td><strong>{{ item?.custonoturno | currency: "BRL" }}</strong></td>
              <!-- <td><strong>{{ item?.subtotalcusto | currency: "BRL" }}</strong></td> -->
              <!-- <td>{{ item?.inss | currency: "BRL" }}</td> -->
              <!-- <td>{{ item?.icms | currency: "BRL" }}</td> -->
              <!--<td>{{ item?.iss | currency: "BRL" }}</td>
                            <td>{{ item?.valorcustomensal | currency: "BRL" }}</td>-->
              <!-- <td>{{ item?.valorresultadomensal | currency: "BRL" }}</td> -->
            </tr>
          </tbody>
          <!-- <tfoot>
                        <tr class="active">
                            <td colspan="13">
                                <div class="col-lg-12 text-right">
                                    Valor Mensal Serviços: <strong>{{ data.orcamento.valortotalservico | currency: "BRL"
                                        }}</strong>
                                </div>
                            </td>
                        </tr>
                    </tfoot> -->
        </table>
      </div>
    </div>
  </div>
  <div class="col-lg-12" style="padding: 0;">
    <div class="panel panel-default" style="margin: 20px 0;">
      <div class="panel-heading"><strong>Produtos</strong></div>
      <div class="table-responsive">
        <table class="table">
          <thead>
            <tr>
              <th>Produto</th>
              <th style="width: 10%;">Qnt</th>
              <!-- <th>Val. Unit.</th>
                            <th>Custo</th>
                            <th>Subtotal</th>
                            <th>Subtotal Custo</th>
                            <th>Custo Mensal</th>
                            <th>Lucro Mensal</th> -->
            </tr>
          </thead>
          <tbody *ngFor="let item of data.orcamento.produtos">
            <tr>
              <td>{{ item.descricao | titlecase }}</td>
              <td>{{ item.quantidade }}</td>
              <!-- <td>{{ item.valorunitario | currency: "BRL" }}</td>
                            <td>{{ item.custo | currency: "BRL" }}</td>
                            <td><strong>{{ item.subtotal | currency: "BRL" }}</strong></td>
                            <td><strong>{{ item.subtotalcusto | currency: "BRL" }}</strong></td>
                            <td>{{ item.valorcustomensal | currency: "BRL" }}</td>
                            <td>{{ item.valorresultadomensal | currency: "BRL" }}</td> -->
            </tr>
          </tbody>
          <!-- <tfoot>
                        <tr class="active">
                            <td colspan="13">
                                <div class="col-lg-12 text-right">
                                    Valor Mensal Produtos: <strong>{{ data.orcamento.valortotalproduto | currency: "BRL"
                                        }}</strong>
                                </div>
                            </td>
                        </tr>
                    </tfoot> -->
        </table>
      </div>
    </div>

  </div>
  <!-- <div class="row">
        <div class="col-md-4">
            <div class="card-counter primary">
                <i class="glyphicon glyphicon-usd"></i>
                <span class="count-numbers">{{ data.orcamento.valortotalservico + data.orcamento.valortotalproduto |
                    currency: "BRL" }}</span>
                <span class="count-name">Total Valor Mensal</span>
            </div>
        </div>
         <div class="col-md-4">
            <div class="card-counter info">
                <i class="glyphicon glyphicon-usd"></i>
                <span class="count-numbers">{{ (data.orcamento.valortotalservico + data.orcamento.valortotalproduto) *
                    data.orcamento.quantidade | currency: "BRL" }}</span>
                <span class="count-name">Total Valor por: {{data.orcamento.quantidade}} {{data.orcamento.unidade}}</span>
            </div>
        </div>
         <div class="col-md-4">
            <div class="card-counter success">
                <i class="glyphicon glyphicon-usd"></i>
                <span class="count-numbers">{{ RetornarLucro() | currency: "BRL" }}</span>
                <span class="count-name">Resultado Total</span>
            </div>
        </div>
    </div> -->
</mat-dialog-content>
<mat-dialog-actions align="end">
  <div class="painel-footer">
    <button type="button" class="btn btn-secondary" (click)="dialogRef.close()">Fechar</button>
  </div>
</mat-dialog-actions>